import {createFileRoute} from '@tanstack/react-router'
import {PaymentProcess} from "@/components/wallet/PaymentProcess/PaymentProcess"

export const Route = createFileRoute('/_mainLayout/wallet/payment-process/')({
  component: RouteComponent,
})

function RouteComponent() {
  return <PaymentProcess/>
}
